import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';
import clickOutside from 'click-outside';
import announcer from './aria-announcer';

const btns = document.querySelectorAll('.btn-search');
const panel = document.querySelector('.search-panel');
const btnClose = panel?.querySelector('.btn-close');
const body = document.querySelector('body');
const btnMobileMenu = document.querySelector('.btn-mobile');

let focusTrap = null;
let unbindClickOutside = null;
let activeBtn = null;

const closePanel = () => {
    activeBtn?.setAttribute('aria-expanded', 'false');
    panel.classList.remove('expanded');
    panel.setAttribute('aria-hidden', 'true');
    body.classList.remove('locked');
    announcer.announce('La section recherche est fermé');

    if (btnMobileMenu && !btnMobileMenu.classList.contains('open')) {
        enableBodyScroll(panel);
    }

    if (focusTrap) {
        focusTrap.deactivate();
        focusTrap = null;
    }

    if (unbindClickOutside) {
        unbindClickOutside();
        unbindClickOutside = null;
    }

    activeBtn = null;
};

const openPanel = (btn) => {
    panel.classList.add('expanded');
    panel.removeAttribute('aria-hidden');
    btn.setAttribute('aria-expanded', 'true');
    disableBodyScroll(panel);
    activeBtn = btn;

    setTimeout(() => {
        focusTrap = createFocusTrap(panel, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
        unbindClickOutside = clickOutside(panel, closePanel);
        announcer.announce('La section recherche est ouverte');
    }, 100);
};

btns.forEach((btn) => {
    btn.addEventListener('click', () => {
        const isExpanded = panel?.classList.contains('expanded');

        if (isExpanded) {
            closePanel();
        } else {
            openPanel(btn);
        }
    });
});

btnClose?.addEventListener('click', closePanel);
